export const DECODER_VALUE_MAP = {
  OFF: {
    code: 0,
    label: 'DecoderValueOff',
    raw: 'Off',
  },
  ON: {
    code: 1,
    label: 'DecoderValueOn',
    raw: 'On',
  },
  INRUSH_LOW_VOLTAGE: {
    code: 2,
    label: 'DecoderValueInrushLowVoltage',
    raw: 'Inrush error, line voltage is too low',
  },
  HOLD_LOW_VOLTAGE: {
    code: 4,
    label: 'DecoderValueHoldLowVoltage',
    raw: 'Hold error, line voltage is too low',
  },
  RESISTANCE_OUT_OF_RANGE: {
    code: 8,
    label: 'DecoderValueResistanceOutOfRange',
    raw: 'Resistance too low / high',
  },
  INDUCTANCE_OUT_OF_RANGE: {
    code: 16,
    label: 'DecoderValueInductanceOutOfRange',
    raw: 'Inductance too low / high',
  },
  LEAK_TOO_HIGH: {
    code: 32,
    label: 'DecoderValueLeakTooHigh',
    raw: 'Leak too high',
  },
  HOLD_RESISTANCE_OUT_OF_RANGE: {
    code: 64,
    label: 'DecoderValueHoldResistanceOutOfRange',
    raw: 'Hold resistance too low / high',
  },
  HOLD_TEST_FAILED: {
    code: 128,
    label: 'DecoderValueHoldTestFailed',
    raw: 'Hold test failed',
  },
  HOLD_TEST_DUAL_COIL_PASSIVE: {
    code: 192,
    label: 'DecoderValueHoldTestDualCoilPassive',
    raw: 'Hold test for dual coil, one plunger was in passive state',
  },
  RESISTANCE_TOO_LOW: {
    code: 264,
    label: 'DecoderValueResistanceTooLow',
    raw: 'Resistance too low',
  },
  HOLD_RESISTANCE_TOO_LOW: {
    code: 320,
    label: 'DecoderValueHoldResistanceTooLow',
    raw: 'Hold resistance too low',
  },
  RESISTANCE_TOO_HIGH: {
    code: 520,
    label: 'DecoderValueResistanceTooHigh',
    raw: 'Resistance too high',
  },
  HOLD_RESISTANCE_TOO_HIGH: {
    code: 576,
    label: 'DecoderValueHoldResistanceTooHigh',
    raw: 'Hold resistance too high',
  },
  INDUCTANCE_TOO_LOW: {
    code: 1040,
    label: 'DecoderValueInductanceTooLow',
    raw: 'Inductance too low',
  },
  INDUCTANCE_TOO_HIGH: {
    code: 2064,
    label: 'DecoderValueInductanceTooHigh',
    raw: 'Inductance too high',
  },
} as const

export const DECODER_VALUE_UNKNOWN_LABEL = 'DecoderValueUnknown'

type DecoderValueEntry = (typeof DECODER_VALUE_MAP)[keyof typeof DECODER_VALUE_MAP]

const CODE_TO_ENTRY = new Map<number, DecoderValueEntry>(
  Object.values(DECODER_VALUE_MAP).map((entry) => [entry.code, entry]),
)

export const getDecoderValueEntry = (
  rawValue: number | null | undefined,
): DecoderValueEntry | null => {
  if (rawValue == null || !Number.isFinite(rawValue)) return null
  return CODE_TO_ENTRY.get(rawValue) ?? null
}

export const formatDecoderValue = (
  rawValue: number | null | undefined,
  t: (key: string) => string,
  fallback = '-',
): string => {
  if (rawValue == null || !Number.isFinite(rawValue)) return fallback
  const entry = CODE_TO_ENTRY.get(rawValue)
  return entry ? t(entry.label) : t(DECODER_VALUE_UNKNOWN_LABEL)
}
